import TheLayout from "../components/layout/TheLayout.vue";
import routesHome from "./routes-home";
import routesUser from "./routes-user";

export default [
  {
    path: "/",
    component: TheLayout,
    redirect: { name: "Home" },
    children: [...routesHome, ...routesUser],
  },
];
